import React, { useState, useEffect } from 'react';
import { Col, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { IoCallOutline, IoMaleFemaleSharp } from 'react-icons/io5';
import { FaBirthdayCake } from 'react-icons/fa';
import { AiOutlineHome, AiOutlineMail } from 'react-icons/ai';
import InformationBlock from 'components/general/InformationBlock';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { GiSwipeCard } from 'react-icons/gi';
const Profile = () => {
  const profileData = useSelector((state) => state.profile.userProfile);
  const currentUserRole = _.get(profileData, 'role', '');
  const phoneNumber = `${_.get(profileData, 'country_code', ' ')}${_.get(profileData, 'phone', ' ')}`;
  const { t } = useTranslation();

  const customerGstins = _.map(profileData.customer_gst_array, (gstin) => _.get(gstin, 'gstin', 'NA'));
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipContent, setTooltipContent] = useState('');

  useEffect(() => {
    const handleOutsideClick = (event) => {
      const tooltip = document.getElementsByClassName('more-button-tooltip')[0];
      if (tooltip && !tooltip.contains(event.target)) {
        setShowTooltip(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  const toggleTooltip = (content) => {
    setShowTooltip(!showTooltip);
    if (content) {
      setTooltipContent(content);
    }
  };

  const renderGstInformationBlock = (icon, infoTitle, remainingNumbers, tooltipId, infoText) => {
    return (
      <Col xl={3} md={6} className="customerProfile-details--wrapper">
        <InformationBlock
          icon={icon}
          infoTitle={
            <>
              {infoTitle}
              {remainingNumbers.length > 0 && (
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip id={tooltipId} className="more-button-tooltip">
                      {remainingNumbers.join(', ')}
                    </Tooltip>
                  }
                  show={showTooltip && tooltipContent === tooltipId}
                  onHide={() => toggleTooltip('')}
                >
                  <span className="more-button" onClick={() => toggleTooltip(tooltipId)}>
                    {t('customerProfile.more')}
                  </span>
                </OverlayTrigger>
              )}
            </>
          }
          infoText={infoText}
        />
      </Col>
    );
  };
  return (
    <div className="profile-details__main">
      <div className="profile-details-inner">
        <div className="profile--content">
          <Row>
            {profileData.gender ? (
              <Col xl={3} md={6} className="profile-details--wrapper">
                <InformationBlock
                  icon={<IoMaleFemaleSharp />}
                  infoTitle={_.capitalize(_.get(profileData, 'gender', '#NA'))}
                  infoText={t('profile.gender')}
                />
              </Col>
            ) : (
              ''
            )}

            {profileData.dob ? (
              <Col xl={3} md={6} className="profile-details--wrapper">
                <InformationBlock
                  icon={<FaBirthdayCake />}
                  infoTitle={profileData.dob ? moment(profileData.dob).format('LL') : ''}
                  infoText={t('profile.birthday')}
                />
              </Col>
            ) : (
              ''
            )}

            <Col xl={3} md={6} className="profile-details--wrapper">
              <InformationBlock icon={<AiOutlineMail />} infoTitle={_.get(profileData, 'email', '')} infoText={t('profile.email')} />
            </Col>
            <Col xl={3} md={6} className="profile-details--wrapper">
              <InformationBlock
                icon={<IoCallOutline />}
                infoTitle={!_.isEmpty(phoneNumber) ? `+${phoneNumber}` : ''}
                infoText={t('profile.phoneNo')}
              />
            </Col>
            {currentUserRole === 'fleet_owner'
              ? !_.isEmpty(profileData.customer_gst_array) &&
                renderGstInformationBlock(<GiSwipeCard />, _.head(customerGstins), _.tail(customerGstins), 'rfid-tooltip', 'GSTIN')
              : ''}
            {profileData.address ? (
              <Col xl={9} md={9} className="profile-details--wrapper">
                <InformationBlock icon={<AiOutlineHome />} infoTitle={_.get(profileData, 'address', '')} infoText={t('profile.address')} />
              </Col>
            ) : (
              ''
            )}
          </Row>
        </div>
      </div>
    </div>
  );
};
export default Profile;
